<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class='bid_item_title'><i class="fa fa-file-audio-o"></i></span>
      <span class='bid_item_title'>Bidding Forecast</span>
      <el-button @click="moreCast" class="bid_more" type="text">more<i class="el-icon-arrow-right el-icon--right"></i></el-button>
    </div>
    <div v-for="(nItem,index) in bidCasteArr" :key="index" class="bid_note_item" @click="seeBidCast(nItem.bidsId)">
      <el-row :gutter="20">
        <!-- <el-col :span="1">
          <div>
            <img src="../../../../static/img/bidding/1.png" alt="">
          </div>
        </el-col> -->
        <el-col :span="19">
          <div class="bid_common_item">
            <span>{{nItem.bidsName}}</span>
          </div>
        </el-col>
        <el-col :span="5">
          <div>{{nItem.promTime}}</div>
        </el-col>
      </el-row>
    </div>
    <div v-show="isCastPage" class="bid_pagination">
      <el-pagination @current-change="pageTurn" :page-size="cPageSize" layout=" prev, pager, next" :total="cPageNoSum">
      </el-pagination>
    </div>
  </el-card>
</template>
<script>
import { bidList } from '@/api/enFrontApi/bidding';
export default {
  data() {
    return {
      isCastPage: false,
      bidCasteArr: [],
      cPageNoSum: 1,
      cPageSize: 10,
      cPageNo: 1
    };
  },
  created() {
    this.initBidCastData(1, 5, false);
  },
  methods: {
    initBidCastData(pageNo, pageSize, flag) {
      if (flag) this.isCastPage = flag;
      else this.isCastPage = false;
      bidList(pageNo, pageSize, 0).then(res => {
        this.cPageNoSum = parseInt(res.data.pageTotal);
        this.bidCasteArr = [];
        this.bidCasteArr = res.data.list;
      });
    },
    seeBidCast(bidsId) {
      if (bidsId) {
        this.$router.push({
          name: 'iaic2019en/biddingInfo',
          params: {
            bidId: bidsId,
            itemNmae: 'Bidding Forecast'
          }
        });
      }
    },
    moreCast() {
      this.$emit('sendBack', 2);
      this.initBidCastData(this.cPageNo, this.cPageSize, true);
    },
    sizeChangeCtl(val) {
      this.cPageSize = val;
      this.initBidCastData(this.cPageNo, this.cPageSize, true);
    },
    pageTurn(val) {
      this.cPageNo = val;
      this.initBidCastData(this.cPageNo, this.cPageSize, true);
    }
  }
};
</script>
<style lang="stylus" scoped>
.bid_note_item {
  height: 28px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/bidding/bidForcast.vue